module.exports = __webpack_public_path__ + "static/media/linkedIn.b938b69f.png";